import styled from "styled-components";
import { Typography, TypographyVariant } from "../../../components/ui-kit";

const Wrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 25%;
  background: #ffffff;
  border: 1px solid #dbe3eb;
  box-shadow: 0px 4px 30px rgba(194, 206, 219, 0.6);
  border-radius: 10px;
  padding: 30px;
  cursor: pointer;
  text-decoration: none;
  p {
    text-align: center;
  }
`;

const Icon = styled.div`
  margin-bottom: 12px;
`;

interface DirectionCardProps {
  data: {
    icon: JSX.Element;
    label: string;
    link: string;
  };
}

const DirectionCard: React.FunctionComponent<DirectionCardProps> = ({
  data: { icon, label, link },
}) => {
  return (
    // <a >
    <Wrapper href={link} target="_blank" rel="noreferrer">
      <Icon>{icon}</Icon>
      <Typography variant={TypographyVariant.BODY5}>{label}</Typography>
    </Wrapper>
    // </a>
  );
};

export default DirectionCard;
